import {
  isDevEnv,
  isIntEnv,
  isLocalEnv,
  isLocalOrDevEnv,
  isProdEnv,
} from '@deepcloud/deep-ui-utils'

export function isLocal() {
  return isLocalEnv(import.meta.env)
}

export function isLocalOrDev() {
  return isLocalOrDevEnv(import.meta.env)
}

export function isDev() {
  return isDevEnv(import.meta.env)
}

export function isProd() {
  return isProdEnv(import.meta.env)
}

export function isInt() {
  return isIntEnv(import.meta.env)
}
